import React from 'react';
import { getImageUrl } from '../config';

// 전체 화면 고정 배경 비디오 (무한 루프, 음소거 자동재생)
// public/images/candle_loop.mp4 는 빌드 시 정적 파일로 포함되어 개발/프로덕션 모두 동일 경로로 서빙됨
const VIDEO_SRC = '/images/candle_loop.mp4';

const VideoBackground: React.FC = () => (
  <video
    autoPlay
    loop
    muted
    playsInline
    preload="auto"
    poster={getImageUrl('bg_image.png')}
    aria-hidden="true"
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      objectFit: 'cover',
      zIndex: -1,
      pointerEvents: 'none',
    }}
  >
    <source src={VIDEO_SRC} type="video/mp4" />
  </video>
);

export default VideoBackground;
